import { type DiscoveryPageViewModel, type ICharacter, useDiscoveryPageController } from "@next-platform/client-common-core";

import useDiscoverNsfwSelection from "./useDiscoverNsfwSelection";
import useDiscoverRecommendationSource from "./useDiscoverRecommendationSource";

const useDiscoverPage = (): DiscoveryPageViewModel<ICharacter> => {
  const isNsfw = useDiscoverNsfwSelection();
  const loadRecommendations = useDiscoverRecommendationSource();

  return useDiscoveryPageController<ICharacter>({ isNsfw, loadRecommendations });
};

export default useDiscoverPage;
